import React from 'react';
import { useNavigate } from 'react-router-dom';


function HowDoesItWork() {

    const navigate = useNavigate()

    return <div className="wp-block-citadela-blocks-custom-container citadela-block-custom-container size-wide bg-type-color inside-space-none has-bg"
    style={{backgroundColor: 'rgba(249, 248, 248, 1)'}}>
    <div className="inner-holder">


        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer responsive-options"
            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;45px&quot;},&quot;mobile&quot;:{&quot;height&quot;:&quot;10px&quot;}}"
            data-block-mobile-breakpoint="782">
            <div className="inner-holder" style={{paddingTop: '45px'}}></div>
        </div>



        <div className="wp-block-columns is-layout-flex wp-container-24 wp-block-columns-is-layout-flex">
            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                <div className="citadela-block-responsive-text weight-700 align-left no-margins responsive-options"
                    data-block-mobile-attr="{&quot;desktop&quot;:{&quot;fontSize&quot;:&quot;26px&quot;,&quot;lineHeight&quot;:1.4},&quot;mobile&quot;:{&quot;fontSize&quot;:&quot;20px&quot;,&quot;lineHeight&quot;:1.4}}"
                    data-block-mobile-breakpoint="782">
                    <p className="inner-tag"
                        style={{fontSize: '26px', fontWeight: '700', lineHeight: '1.4', color: 'rgb(34, 34, 34)'}}>How does it
                        work?</p>
                </div>


                <div className="citadela-block-responsive-text weight-700 align-left no-margins responsive-options"
                    data-block-mobile-attr="{&quot;desktop&quot;:{&quot;fontSize&quot;:&quot;42px&quot;,&quot;lineHeight&quot;:1.1},&quot;mobile&quot;:{&quot;fontSize&quot;:&quot;36px&quot;,&quot;lineHeight&quot;:1.1}}"
                    data-block-mobile-breakpoint="782">
                    <h2 className="inner-tag"
                        style={{fontSize: '42px', fontWeight: '700', lineHeight: '1.1', color: 'rgb(234, 34, 81)'}}>
                        Step-by-step</h2>
                </div>



                <div className="wp-block-citadela-blocks-spacer citadela-block-spacer responsive-options"
                    data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;0px&quot;},&quot;mobile&quot;:{&quot;height&quot;:&quot;30px&quot;}}"
                    data-block-mobile-breakpoint="600">
                    <div className="inner-holder" style={{paddingTop: '0px'}}></div>
                </div>
            </div>


        </div>



        <div className="wp-block-columns is-layout-flex wp-container-28 wp-block-columns-is-layout-flex">
            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                <div className="wp-block-citadela-blocks-custom-container citadela-block-custom-container size-content bg-type-none inside-space-small has-shadow has-min-height vertical-align-top"
                    style={{minHeight: '200px', boxShadow: '-1px 0px 0px 0px rgba(228, 228, 228, 1)'}}>
                    <div className="inner-holder">
                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height">
                            <div className="inner-holder" style={{marginTop: '-25px'}}></div>
                        </div>


                        <div className="citadela-block-responsive-text weight-900 align-left no-margins">
                            <p className="inner-tag" style={{fontSize: '54px', fontWeight: '900', color: '#d6cfd1'}}>01.</p>
                        </div>


                        <div className="citadela-block-responsive-text align-left">
                            <h3 className="inner-tag">Choose your food</h3>
                        </div>



                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer">
                            <div className="inner-holder" style={{paddingTop: '10px'}}></div>
                        </div>


                        <div className="citadela-block-responsive-text align-left">
                            <p className="inner-tag" style={{lineHeight: '1.8'}}>Select from wide range of meals or treats or
                                both, no judgments :)</p>
                        </div>



                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height responsive-options"
                            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;-10px&quot;,&quot;negative&quot;:true},&quot;mobile&quot;:{&quot;height&quot;:&quot;0px&quot;}}"
                            data-block-mobile-breakpoint="600">
                            <div className="inner-holder" style={{marginTop: '-10px'}}></div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                <div className="wp-block-citadela-blocks-custom-container citadela-block-custom-container size-content bg-type-none inside-space-small has-shadow has-min-height vertical-align-top"
                    style={{minHeight: '200px', boxShadow: '-1px 0px 0px 0px rgba(228, 228, 228, 1)'}}>
                    <div className="inner-holder">
                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height">
                            <div className="inner-holder" style={{marginTop: '-25px'}}></div>
                        </div>


                        <div className="citadela-block-responsive-text weight-900 align-left no-margins">
                            <p className="inner-tag" style={{fontSize: '54px', fontWeight: '900', color: '#d6cfd1'}}>02.</p>
                        </div>


                        <div className="citadela-block-responsive-text align-left">
                            <h3 className="inner-tag">Delivery or takeout</h3>
                        </div>



                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer">
                            <div className="inner-holder" style={{paddingTop: '10px'}}></div>
                        </div>


                        <div className="citadela-block-responsive-text align-left">
                            <p className="inner-tag" style={{lineHeight: '1.8'}}>Have your food delivered or pick it up
                                yourself at one of our bistros</p>
                        </div>



                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height responsive-options"
                            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;-10px&quot;,&quot;negative&quot;:true},&quot;mobile&quot;:{&quot;height&quot;:&quot;0px&quot;}}"
                            data-block-mobile-breakpoint="600">
                            <div className="inner-holder" style={{marginTop: '-10px'}}></div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                <div className="wp-block-citadela-blocks-custom-container citadela-block-custom-container size-content bg-type-none inside-space-small has-shadow has-min-height vertical-align-top"
                    style={{minHeight: '200px', boxShadow: '-1px 0px 0px 0px rgba(228, 228, 228, 1)'}}>
                    <div className="inner-holder">
                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height">
                            <div className="inner-holder" style={{marginTop: '-25px'}}></div>
                        </div>


                        <div className="citadela-block-responsive-text weight-900 align-left no-margins">
                            <p className="inner-tag" style={{fontSize: '54px', fontWeight: '900', color: '#d6cfd1'}}>03.</p>
                        </div>


                        <div className="citadela-block-responsive-text align-left">
                            <h3 className="inner-tag">Enjoy the food your way</h3>
                        </div>



                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer">
                            <div className="inner-holder" style={{paddingTop: '10px'}}></div>
                        </div>


                        <div className="citadela-block-responsive-text align-left">
                            <p className="inner-tag" style={{lineHeight: '1.8'}}>Wherever it tastes better for you, however
                                you are always welcome at our bistro!</p>
                        </div>



                        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height responsive-options"
                            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;-10px&quot;,&quot;negative&quot;:true},&quot;mobile&quot;:{&quot;height&quot;:&quot;0px&quot;}}"
                            data-block-mobile-breakpoint="600">
                            <div className="inner-holder" style={{marginTop: '-10px'}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer responsive-options"
            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;20px&quot;},&quot;mobile&quot;:{&quot;height&quot;:&quot;0px&quot;}}"
            data-block-mobile-breakpoint="900">
            <div className="inner-holder" style={{paddingTop: '20px'}}></div>
        </div>



        <div onClick={() => navigate("/browse")} className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
            <div className="wp-block-button"><a className="wp-block-button__link wp-element-button" href
                    style={{borderRadius: '5px'}}>Order Now</a></div>

        </div>



        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer responsive-options"
            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;0px&quot;},&quot;mobile&quot;:{&quot;height&quot;:&quot;-10px&quot;,&quot;negative&quot;:true}}"
            data-block-mobile-breakpoint="782">
            <div className="inner-holder" style={{paddingTop: '0px'}}></div>
        </div>
    </div>
</div>
}


export default HowDoesItWork